<template>
  <transition name="mega-fade">
    <div id="mega-menu-mb" class="absolute left-0 right-0">
      <div class="px-20">
        <div class="user flex py-30 bd-b-1 bd-hairline justify-between">
          <div class="item">
            <div v-if="is_verified || userInfo?.user_id" class="flex items-center hand hp-100" @click="toAccountSettings">
              <div>
                <div class="circle">
                  <span v-if="!avatar">{{ getUserName }}</span>
                  <img v-else class="img-cover" :src="avatar" alt="" />
                </div>
              </div>
              <div class="ink">
                <div class="fs-12 lh-14 fw-700">
                  {{ firstName + ' ' + lastName }}
                </div>
                <div class="fs-13 lh-16">Account Settings</div>
              </div>
            </div>
            <button v-else class="button button-outline wp-100" @click="toLogin">Login</button>
          </div>
          <div class="item" v-if="!is_verified || !userInfo?.user_id">
            <button class="button button-outline wp-100" @click="toSignUp">Sign Up</button>
          </div>
          <div class="item" >
            <button v-if='!showEnquiryButton' class="button button-accent wp-100" @click="toDesignTrip">Enquire</button>
          </div>
        </div>
        <div v-if="is_verified || userInfo?.user_id" class="flex items-center justify-center bd-b-1 bd-hairline py-20">
          <div :class="designBlockClass" class="hand" @click="toEnquiries">
            <img :src="`${$assetsCdn}/icons/my-enquiries.png`" class="mb-8" height="20" alt="" />
            Enquiries
          </div>
          <div class="w-20"></div>
          <div class="hand" :class="designBlockClass" @click="redirectToBooking">
            <img :src="`${$assetsCdn}/icons/suitcase.png`" class="mb-8" height="20" alt="" />
            Bookings
          </div>
        </div>
        <div v-if="domain === 'traveller'" id="sub-nav-mb-how-it-works" class="bd-b-1 bd-hairline py-20 parent-nav-mb" h="browse-top-menu">
          <div class="flex items-center wp-100" @click="handleSubNav(howItWorks)">
            <span class="fs-14 lh-18 fw-700 pr-10">{{ howItWorks.title }}</span>
          </div>
        </div>
        <div
          v-for="(item, index) in topMenu"
          :key="`item-${index}`"
          :id="`sub-nav-mb-${item.name}`"
          class="bd-b-1 bd-hairline py-20 parent-nav-mb"
          h="browse-top-menu"
        >
          <div class="flex items-center wp-100" @click="handleSubNav(item)">
            <span class="fs-14 lh-18 fw-700 pr-10">{{ item.title }}</span>
            <span v-if="item.sub_nav" class="flex items-center justify-center">
              <img class="icon-up" :src="`${$assetsCdn}/icons/chevron-up.svg`" alt="" />
              <img class="icon-down" :src="`${$assetsCdn}/icons/chevron-down.svg`" alt="" />
            </span>
          </div>
          <div v-show="item.sub_nav" class="sub-tab">
            <TabsMB v-if="`sub-nav-mb-${item.name}` === menuItemSelected" :list="item" @openURL="handleSubNav(item)"></TabsMB>
          </div>
        </div>
        <div v-for="(item, index) in list" :key="`item-${index}`" :id="`sub-nav-mb-${item.name}`" class="bd-b-1 bd-hairline py-20 parent-nav-mb">
          <div class="flex items-center wp-100" @click="handleSubNav(item)">
            <span class="fs-14 lh-18 fw-700 pr-10">{{ item.title }}</span>
          </div>
        </div>
        <div class="flex items-center flex-wrap py-20">
          <span>
            <img :src="`${$assetsCdn}/icons/phone-call-12x12.png`" height="12" width="12" alt="Phone" />
          </span>
          <a href="tel: +613 9071 0069"><span class="fw-700 pl-10 fs-14 lh-18 black">03 9071 0069</span></a>
          <span class="px-10">
            <img class="mt-4" :src="`${$assetsCdn}/icons/australia.png`" height="16" width="16" alt="Australia" />
          </span>
          <span class="fs-12 lh-14">Monday to Friday 8am-9pm (AEDT)</span>
        </div>
      </div>
      <div class="px-20 bg-cream-deep">
        <div
          v-for="(item, index) in userNavMB"
          :key="index"
          :id="`sub-nav-mb-${item.name}`"
          class="flex items-center flex-wrap parent-nav-mb"
          :class="{
            'bd-b-1 bd-hairline py-20': item.title !== 'Logout' || is_verified || userInfo?.user_id,
          }"
        >
          <div class="flex items-center wp-100" @click="handleSubNav(item)">
            <span class="fs-14 lh-18 fw-700 pr-10" v-if="item.title !== 'Logout'">{{ item.title }}</span>
            <span v-if="item.sub_nav" class="flex items-center justify-center">
              <img class="icon-up" :src="`${$assetsCdn}/icons/chevron-up.svg`" alt="" />
              <img class="icon-down" :src="`${$assetsCdn}/icons/chevron-down.svg`" alt="" />
            </span>
            <span class="fs-14 lh-18 fw-700 pr-10 hand" @click.stop="handleLogout" v-else-if="is_verified || userInfo?.user_id">{{ item.title }}</span>
          </div>
          <div v-show="item.sub_nav" class="sub-tab">
            <DropDown v-if="`sub-nav-mb-${item.name}` === menuItemSelected" :list="item.sub_nav"></DropDown>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
// import { getCookie, setCookie } from '~/mixins/cookie'
import { useGetCookie } from '~/composables/common/useCustomCookie'
import { computed, ref, onMounted, watch } from 'vue'
import TabsMB from './items/TabsMB'
import { useRoute, useRouter } from 'vue-router'
import DropDown from '../MenuMobile/DropDown'
import { publicDomain } from '~/helper'
import { TfChat } from 'tf-chat'
import { pages } from '~/constant/redirectLogout'
import { useAuthStore } from '~/store/pinia/auth'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

// ---Props & Emit---
const props = defineProps({
  list: { type: [Object, Array] },
  headerType: {
    type: String,
    default: 'Traveller', // Traveller, Agent, DesignAgent
  },
  userData: {
    type: Object,
    default: () => {},
  },
})

// ---Define---
const userNavMB = [
  {
    title: 'For Local Designers',
    name: 'for local-designers',
    sub_nav: [
      {
        title: 'Become a Local Designer',
        url: '/become-a-local-designer',
      },
      {
        title: 'Local Designer Login',
        url: 'https://extranet.designerjourneys.com/access/admin/',
      },
    ],
  },
  {
    title: 'For Travel Agents',
    name: 'for travel-agents',
    sub_nav: [
      {
        title: 'Become a Travel Agent',
        url: '/sign-up-travel-agent',
      },
      {
        title: 'Travel Agent Login',
        url: useAppConfig().publicDomainAgent,
      },
    ],
  },
  {
    title: 'Logout',
    name: 'logout',
    url: '/',
  },
]
const designBlockClass = 'bg-cream-deep flex items-center justify-center flex-column wp-50 br-8 h-80 fw-700 fs-14 lh-18'
const howItWorks = {
  title: 'How It Works',
  name: 'how-it-works',
  url: '/how-it-works',
}

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const generalStore = useGeneralInfoStore()
// const subNavOpen = ref('')
const domain = publicDomain()
// const is_verified = getCookie('is_verified=')
const is_verified = useGetCookie('is_verified')
const dj_xxer_hash = useGetCookie('dj_xxer_hash',365)
const dj_uid = useGetCookie("dj_uid", 365)
const firstName = ref('')
const lastName = ref('')
const avatar = ref(null)
const getUserName = ref('')
const tokenChat = ref('')

// ---Computed
const showEnquiryButton = computed(() => {
  const domain = publicDomain()
  const routeNameTV = [
    'enquiry-confirmation','local-designer','trip-plan-bookable', 'bookings-listing','booking-details',
    'enquiries-listing','account-settings', 'login-traveller','signup-traveller','signup-agent',
    'forgot-password','become-local-designer','private-group-tours', 'sign-up-travel-agent']
  return (((domain === 'traveller') && (route.name === 'trip-plan'))  
    || ((domain === 'traveller') && (routeNameTV.indexOf(route.name) !== -1)))
})
// const tabOpen = computed(() => generalStore.generalData.megaMenuInforMB.statusSubNav)
const menuItemSelected = computed(() => generalStore.generalData.megaMenuInforMB.itemSelected)
const topMenu = computed(() => generalStore.topMenuData)
const userInfo = computed(() => authStore.getUserInfo)

const designURL = () => {
  // if (domain === 'agent') return { name: 'gallery-enquiry-steps' }
  if (route.name === 'types-gallery' && route.params?.types_) {
    // return { name: 'gallery-enquiry-steps', params: { galleryTypes: route.params.types, steps: 'where' } }
    return {
      name: 'enquiry-submit-destination',
      params: { galleryTypes: route.params?.types_ },
    }
  }
  if ((route.name === 'gallery-local-designers' && route.params.country_) || (route.name === 'country-travel-guide' && route.params.country)) {
    // if(process.env.VUE_APP_ENQUIRY_SINGLE) return { name: 'enquiry-submit-destination', params: { galleryTypes: route.params.country } }
    return {
      name: 'enquiry-submit-destination',
      params: { galleryTypes: route.params.country },
    }
  }
  // return { name: 'enquiry-steps', params: { steps: 'where' } }
  return { name: 'enquiry-submit-global' }
}

// ---Watch---
watch(
  () => route.name,
  () => {
    generalStore.setTabIndex(0)
    const data = {
      status: false,
      itemSelected: '',
    }
    generalStore.setMegaMenuStatusMB(data)
  },
)
watch(
  () => props.userData,
  (data) => {
    userInfo.value = data
    firstName.value = userInfo.value?.first_name
    lastName.value = userInfo.value?.last_name
    avatar.value = userInfo.value?.avatar
    if (firstName.value && lastName.value) {
      getUserName.value = firstName.value.charAt(0).toUpperCase() + lastName.value.charAt(0).toUpperCase()
    }
    // console.log('MegaMenuMobile watch: ',userInfo.value,' == ', firstName.value,' == ',lastName.value)
  },
)

// ---Method---
const handleLogout = async () => {
  // console.log(route.name);
  // const COOKIE_DURATION = 0
  await authStore.logout()
  // setCookie('is_verified', 0, COOKIE_DURATION)
  // setCookie('dj_xxer_hash', 0, COOKIE_DURATION)
  is_verified.value = null
  dj_xxer_hash.value = null
  dj_uid.value = null
  localStorage.removeItem('chat_array')
  sessionStorage.removeItem('auth_path')
  if (pages.includes(route.name)) {
    window.location.href = '/'
  } else {
    window.location.reload()
  }
}

const redirectToBooking = () => {
  closeMegaMenu()
  router.push({ name: 'bookings-listing' })
}
const closeMegaMenu = () => {
  const data = {
    status: false,
    statusSubNav: false,
    itemSelected: '',
  }
  generalStore.setMegaMenuStatusMB(data)
}
const toDesignTrip = () => {
  closeMegaMenu()
  router.push(designURL())
}
const toLogin = () => {
  closeMegaMenu()
  if (domain === 'agent') {
    router.push({ name: 'home' })
  } else {
    router.push({ name: 'login-traveller' })
  }
}
const toSignUp = () => {
  closeMegaMenu()
  if (domain === 'agent') {
    router.push({ name: 'signup-agent' })
  } else {
    router.push({ name: 'signup-traveller' })
  }
}
const toAccountSettings = () => {
  closeMegaMenu()
  router.push({ name: 'account-settings' })
}
const toEnquiries = () => {
  closeMegaMenu()
  router.push({ name: 'enquiries-listing' })
}
// const getNavHeight = (item) => {
//   const element = document.getElementById(`sub-nav-mb-${item.name}`)
//   let height = element.offsetHeight
//   return `${height}px`
// }
// const handleActive = (e) => {
//   console.log(e)
// }
const handleSubNav = (item) => {
  if (item.sub_nav) {
    if (!menuItemSelected.value || menuItemSelected.value === `sub-nav-mb-${item.name}`) {
      const element = document.getElementById(`sub-nav-mb-${item.name}`)
      element.classList.toggle('active')

      const data = {
        status: true,
        statusSubNav: element,
        itemSelected: `sub-nav-mb-${item.name}`,
      }
      generalStore.setMegaMenuStatusMB(data)
    } else {
      document.getElementById(menuItemSelected.value).classList.remove('active')
      const element = document.getElementById(`sub-nav-mb-${item.name}`).classList.toggle('active')
      const data = {
        status: true,
        statusSubNav: element,
        itemSelected: `sub-nav-mb-${item.name}`,
      }
      generalStore.setMegaMenuStatusMB(data)
    }
  } else {
    generalStore.setTabIndex(0)
    const data = {
      status: false,
      statusSubNav: false,
      itemSelected: '',
    }
    generalStore.setMegaMenuStatusMB(data)
    if (item.url !== '') {
      router.push({ path: item.url })
    } else {
      window.open(item.externalURL, '_blank')
    }
  }
}

const userLogin = async () => {
  // console.log('MegaMenuMobile onMounted: ',userInfo.value)
  if (is_verified.value || userInfo.value.user_id) {
    // const checkHash = getCookie('dj_xxer_hash=')
    try {
      await authStore.verify()
      if(userInfo.value.status === 200) {
        firstName.value = userInfo.value.firstName
        lastName.value = userInfo.value.lastName
        avatar.value = userInfo.value.avatar
        getUserName.value = firstName.value.charAt(0).toUpperCase() + lastName.value.charAt(0).toUpperCase() || ''
        tokenChat.value = userInfo.value.token
        let sdkToken = tokenChat.value
        sdkToken && await TfChat.init(sdkToken)
        if (!dj_xxer_hash.value) {
          // setCookie('dj_xxer_hash', userInfo.value.hash, COOKIE_DURATION)
          dj_xxer_hash.value = userInfo.value.hash
        }
      } else {
        await authStore.logout()
        is_verified.value = null
        dj_xxer_hash.value = null
        dj_uid.value = null
        window.location.reload()
        localStorage.removeItem('chat_array')
        sessionStorage.removeItem('auth_path')
      }
    } catch (err) {
      if ((err?.status || err?.response?.status) === 401) {
        // const COOKIE_DURATION = 0
        await authStore.logout()
        // setCookie('is_verified', 0, COOKIE_DURATION)
        // setCookie('dj_xxer_hash', 0, COOKIE_DURATION)
        is_verified.value = null
        dj_xxer_hash.value = null
        dj_uid.value = null
        window.location.reload()
        localStorage.removeItem('chat_array')
        sessionStorage.removeItem('auth_path')
      }
    }
  }
}

// ---Mounted---
onMounted(async ()=>{
  await nextTick(async()=> await userLogin())
})
</script>

<style lang="scss" scoped>
#mega-menu-mb {
  background-color: $surface-warm; // §7 — cream drawer surface (Wave 7 → seam, #141414 dark)
  height: 100%;
  overflow-y: auto;
  scrollbar-color: transparent $brand-green; // brand scrollbar (was $blue-branding)
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    // width: 14px;
    width: 0;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    border: 5px solid transparent;
    background-clip: content-box;
    background-color: $brand-green; // brand scrollbar thumb (was $blue-branding)
    border-radius: 100px;
  }
  .circle {
    @extend %circle;
  }
  .user {
    .item {
      flex: 1 1 0%;
      margin-right: 20px;
      &:last-of-type {
        margin-right: 0;
        max-width: 33%;
      }
      button {
        height: 100%;
        padding-right: 22px;
        padding-left: 22px;
      }
    }
  }
  // @media screen and (max-width: 330px)  {
  //   .user {
  //     .item {
  //       flex: 1 1 0%;
  //       margin-right: 3px;

  //       &:last-of-type {
  //         margin-right: 0;
  //       }
  //       button {
  //         padding-right: 0;
  //         padding-left: 0;
  //       }
  //     }
  //   }
  // }
}

.parent-nav-mb {
  /*-webkit-transition: height .8s ease-in-out;
  transition: height .8s ease-in-out;*/
  .sub-tab {
    transition: opacity $dur-slow $ease-out, transform $dur-slow $ease-out; // §11 accordion (was 0.3s ease-in-out)
    opacity: 0;
    height: 0;
    visibility: hidden;
    display: none;
  }
  .icon-up {
    display: none;
  }
  &.active {
    .sub-tab {
      opacity: 1;
      transform: translateX(0);
      height: auto;
      visibility: visible;
      display: block;
    }
    .icon-down {
      display: none;
    }
    .icon-up {
      display: block;
    }
  }
}
/*.button-blue {
  background: rgba(164, 203, 250, 0.3);
}
.button-blue-dark {
  background: #A5CAFA;
  color: black;
}*/

// Dark mode — several icons in this drawer are dark line PNGs / SVGs loaded as <img>, so CSS can't
// recolour them; on the dark drawer ($surface-warm #141414, and the bg-cream-deep #1A1A1A profile
// tiles) they're invisible. Invert to near-white — <img> → filter (root cause #2). Dark-only, so
// light mode is byte-identical.
//   • logged-in profile tiles: my-enquiries.png (Enquiries) / suitcase.png (Bookings)
//   • browse-nav expand chevrons: .icon-up / .icon-down (chevron-up.svg / chevron-down.svg)
//   • contact phone: phone-call-12x12.png
// (The australia.png flag + the avatar photo are colour images and are left untouched.)
[data-theme='dark'] {
  img[src*='my-enquiries.png'],
  img[src*='suitcase.png'],
  img[src*='phone-call-12x12.png'],
  .icon-up,
  .icon-down {
    filter: brightness(0) invert(1);
  }
}
</style>
